import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Button, Radio, RadioChangeEvent, Space } from 'antd'
import { DownOutlined, UpOutlined, EyeOutlined } from '@ant-design/icons'
import './OrderHistoryCard.scss'

import { mixGetV2, mixPostV2 } from '../../../services/mixin'
import MegaTable from '../../../pages/Customers/cpnMagaTable'
import ColSetting from '../../../components/Filter/ColSetting'
import { useNavigate } from 'react-router-dom';

interface Props {
  value?: any
  title?: string
  nameTableCache: string,
  listData?: any[]
  istab?: any
  onChange?: (data: any, type: string) => void
}


const PoolingDataHistoryCard: React.FC<Props> = ({ title, value, nameTableCache, listData, istab, onChange }) => {
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(true)
  const [megaTableData, setMegaTableData] = useState<any>({
    col: [],
    listData: [],
    open: false,
    loading: true,
    hideRowsSelect: true,
  })

  const [loading, setLoading] = useState(false)
  const [tempColData, setTempColData] = useState<any[]>([])

  const saveCacheTimeout = useRef<NodeJS.Timeout | null>(null)

  // Debounced Save Cache Function
  const saveCache = useCallback(async (data: any, name: string) => {
    if (!value?.idUser) return
    if (saveCacheTimeout.current) clearTimeout(saveCacheTimeout.current)
    saveCacheTimeout.current = setTimeout(async () => {
      try {
        const param = {
          name: nameTableCache,
          user_id_thaco: value.idUser,
          data_json: JSON.stringify(data),
        }
        await mixPostV2('/api/v1/be/user_thaco_json', param)
      } catch (e) {
        // Handle error
      }
    }, 800)
  }, [value?.idUser])

  // Column Data
    useEffect(() => {
      let ignore = false;
      if (!value?.idUser) return

      async function getcolumn() {
        const [res2] = await Promise.all([
          mixPostV2(`/api/v1/be/user_thaco_json_more`, {
            user_id_thaco: value?.idUser,
            name: JSON.stringify([nameTableCache]),
          }),
        ]);
        if (!ignore && res2.status) {
          matchCols(value.col, res2.status && res2.data.items[0] ? JSON.parse(res2.data.items[0].data_json) : {});
        }
      }
      getcolumn();
      return () => { ignore = true; }
      // eslint-disable-next-line
    }, [value?.idUser]);

  // Build Columns from value.col & value.jsonData
  const matchCols = useCallback((cols: any[] = [], dataJson: any) => {
    const tbCache = dataJson
    const ob = tbCache.listData ?? {}

    let temp = [
      {
        headerName: 'ID',
        field: 'warehouse_id_origin',
        colId: 'warehouse_id_origin',
        width: ob['warehouse_id_origin']?.width ?? 100,
        pos: ob['warehouse_id_origin']?.pos ?? 0,
        hide: ob['warehouse_id_origin']?.hide ?? false,
      },
    ] as any

    if (value.action) {
      temp = [
        {
          headerName: "Hành động",
          field: "hanhdong",
          colId: "hanhdong",
          width: ob['hanhdong'] ? ob['hanhdong'].width : 100,
          pos: ob['hanhdong'] ? ob['hanhdong'].pos : 0,
          hide: ob['hanhdong'] ? ob['hanhdong'].hide : false,
          cellRenderer: (params: any) => (
            <Space size="middle">
              <EyeOutlined
                className='text-sm border-EAECF0 p-5-px bg-white rounded-2'
                onClick={() => {
                  navigate(`/customer/pooling-data/history-maintenance/${params.data.unknown_field_13}`);
                }}
              />
            </Space>
          )
        },
        ...temp,
      ]
    }

    const firstView = Object.keys(ob).length === 0
    cols.forEach((val: any, index: number) => {
      temp.push({
        headerName: val.name,
        field: val.column_warehouse.column,
        colId: val.id,
        width: ob[val.id]?.width ?? 100,
        pos: ob[val.id]?.pos ?? index,
        hide: firstView ? !(val.is_default === 1) : ob[val.id]?.hide ?? true,
        cellRenderer: (params: any) => <div className='table-wrap-text'>{params.value}</div>,
      })
    })

    temp.sort((a: any, b: any) => a.pos - b.pos)

    setMegaTableData((prev: any) => ({
      ...prev,
      col: temp,
      screen: tbCache.screen || window.innerWidth,
    }))
    setTempColData(temp)
  }, [])

  // handle MegaTable Change
  const handleMegaTableChange = useCallback((data: any, type: string) => {
    setTempColData([...data])
    if (type === 'colChange') {
      const temp: any = {}
      data.forEach((val: any, idx: number) => {
        temp[val.colId] = {
          colId: val.colId,
          field: val.field,
          headerName: val.headerName,
          hide: val.hide || false,
          width: val.width,
          pos: idx,
        }
      })
      const newCache = { listData: temp, screen: window.innerWidth }
      saveCache(newCache, nameTableCache)
    }
  }, [saveCache])

  // handle ColSetting Change
  const handleColSettingChange = useCallback((data: any, type: string) => {
    if (type === 'close') {
      setMegaTableData((prev: any) => ({ ...prev, open: false }))
    }
    if (type === 'saveChange') {
      setMegaTableData((prev: any) => ({ ...prev, col: data, open: false }))
      setTempColData([...data])
      const temp: any = {}
      data.forEach((val: any, idx: number) => {
        temp[val.colId] = { ...val, pos: idx }
      })
      const newCache = { listData: temp, screen: window.innerWidth }
      saveCache(newCache, nameTableCache)
    }
  }, [saveCache])

  // When value.idUser change, refresh columns
  // useEffect(() => {
  //   if (value?.col && value?.jsonData) {
  //     matchCols(value.col, value.jsonData)
  //   }
  // }, [value?.idUser]) // only run when user changes

  // Clean up debounce on unmount
  useEffect(() => {
    return () => {
      if (saveCacheTimeout.current) clearTimeout(saveCacheTimeout.current)
    }
  }, [])

  const carTypes = [
    { value: 'xe-dang-su-dung', label: 'Xe đang sử dụng' },
    { value: 'xe-so-hu', label: 'Xe sở hữu' },
    { value: 'xe-quan-tam', label: 'Xe quan tâm' },
  ]
  const onChangeCarType = ({ target: { value } }: RadioChangeEvent) => {
    onChange && onChange(value, 'tabchange')
  }

  return (
    <div className="order-history-card">
      <div className="order-history-card__head">
        {
          value.group ?
            <Radio.Group
              value={istab}
              className='rs-radio-group'
              onChange={onChangeCarType}
            >
              {
                carTypes.map((item: any) => (
                  <Radio.Button
                    key={item.value}
                    value={item.value}
                    className='rs-radio'
                  >{item.label}</Radio.Button>
                ))
              }
            </Radio.Group>
            :
            <span className="title fsz-16 lh-24 font-medium">{title}</span>
        }
        <div className="t-icon-setting" onClick={() => setMegaTableData((prev: any) => ({ ...prev, open: true, col: tempColData }))}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_17841_37421)">
              <path d="M15.3722 10.033L14.2026 9.03304C14.2579 8.69375 14.2865 8.34732 14.2865 8.00089C14.2865 7.65446 14.2579 7.30804 14.2026 6.96875L15.3722 5.96875C15.4604 5.89323 15.5236 5.79264 15.5532 5.68035C15.5829 5.56807 15.5777 5.44942 15.5383 5.34018L15.5222 5.29375C15.2002 4.3938 14.718 3.55953 14.099 2.83125L14.0669 2.79375C13.9918 2.70545 13.8917 2.64198 13.7798 2.61169C13.6679 2.58141 13.5494 2.58574 13.4401 2.62411L11.9883 3.14018C11.4526 2.70089 10.8544 2.35446 10.2079 2.11161L9.92757 0.59375C9.90642 0.47954 9.85102 0.374469 9.76872 0.292496C9.68643 0.210524 9.58115 0.15553 9.46686 0.134821L9.41864 0.125893C8.48829 -0.0419643 7.50971 -0.0419643 6.57936 0.125893L6.53114 0.134821C6.41685 0.15553 6.31156 0.210524 6.22927 0.292496C6.14698 0.374469 6.09158 0.47954 6.07043 0.59375L5.78828 2.11875C5.14701 2.36166 4.54983 2.7079 4.02043 3.14375L2.55793 2.62411C2.44858 2.58543 2.33005 2.58095 2.2181 2.61125C2.10614 2.64155 2.00606 2.7052 1.93114 2.79375L1.899 2.83125C1.28069 3.56004 0.798599 4.39417 0.475785 5.29375L0.459713 5.34018C0.379356 5.56339 0.445428 5.81339 0.625785 5.96875L1.80971 6.97946C1.75436 7.31518 1.72757 7.65804 1.72757 7.99911C1.72757 8.34196 1.75436 8.68482 1.80971 9.01875L0.625785 10.0295C0.537563 10.105 0.474421 10.2056 0.444756 10.3179C0.415091 10.4301 0.420308 10.5488 0.459713 10.658L0.475785 10.7045C0.798999 11.6045 1.27757 12.4348 1.899 13.167L1.93114 13.2045C2.00624 13.2928 2.10633 13.3562 2.21822 13.3865C2.33011 13.4168 2.44855 13.4125 2.55793 13.3741L4.02043 12.8545C4.55257 13.292 5.14721 13.6384 5.78828 13.8795L6.07043 15.4045C6.09158 15.5187 6.14698 15.6237 6.22927 15.7057C6.31156 15.7877 6.41685 15.8427 6.53114 15.8634L6.57936 15.8723C7.51826 16.0411 8.47974 16.0411 9.41864 15.8723L9.46686 15.8634C9.58115 15.8427 9.68643 15.7877 9.76872 15.7057C9.85102 15.6237 9.90642 15.5187 9.92757 15.4045L10.2079 13.8866C10.8541 13.6444 11.4557 13.2968 11.9883 12.858L13.4401 13.3741C13.5494 13.4128 13.6679 13.4173 13.7799 13.387C13.8919 13.3567 13.9919 13.293 14.0669 13.2045L14.099 13.167C14.7204 12.433 15.199 11.6045 15.5222 10.7045L15.5383 10.658C15.6186 10.4384 15.5526 10.1884 15.3722 10.033ZM12.9347 7.17946C12.9794 7.44911 13.0026 7.72589 13.0026 8.00268C13.0026 8.27946 12.9794 8.55625 12.9347 8.82589L12.8169 9.54197L14.1508 10.683C13.9486 11.1489 13.6933 11.5899 13.3901 11.9973L11.7329 11.4098L11.1722 11.8705C10.7454 12.2205 10.2704 12.4955 9.75614 12.6884L9.07578 12.9438L8.75614 14.6759C8.2518 14.733 7.74262 14.733 7.23828 14.6759L6.91864 12.9402L6.24364 12.6813C5.73471 12.4884 5.2615 12.2134 4.83828 11.8652L4.27757 11.4027L2.60971 11.9955C2.30614 11.5866 2.05257 11.1455 1.849 10.6813L3.19721 9.52946L3.08114 8.81518C3.03828 8.54911 3.01507 8.27411 3.01507 8.00268C3.01507 7.72946 3.0365 7.45625 3.08114 7.19018L3.19721 6.47589L1.849 5.32411C2.05078 4.85804 2.30614 4.41875 2.60971 4.00982L4.27757 4.60268L4.83828 4.14018C5.2615 3.79196 5.73471 3.51696 6.24364 3.32411L6.92043 3.06875L7.24007 1.33304C7.74186 1.27589 8.25436 1.27589 8.75793 1.33304L9.07757 3.06518L9.75793 3.32054C10.2704 3.51339 10.7472 3.78839 11.174 4.13839L11.7347 4.59911L13.3919 4.01161C13.6954 4.42054 13.949 4.86161 14.1526 5.32589L12.8186 6.46696L12.9347 7.17946ZM8.00078 4.68125C6.26507 4.68125 4.85793 6.08839 4.85793 7.82411C4.85793 9.55982 6.26507 10.967 8.00078 10.967C9.7365 10.967 11.1436 9.55982 11.1436 7.82411C11.1436 6.08839 9.7365 4.68125 8.00078 4.68125ZM9.41507 9.23839C9.22957 9.42442 9.00913 9.57194 8.76641 9.67246C8.52369 9.77298 8.26349 9.82452 8.00078 9.82411C7.46686 9.82411 6.96507 9.61518 6.5865 9.23839C6.40047 9.0529 6.25295 8.83245 6.15243 8.58973C6.05191 8.34701 6.00038 8.08682 6.00078 7.82411C6.00078 7.29018 6.20971 6.78839 6.5865 6.40982C6.96507 6.03125 7.46686 5.82411 8.00078 5.82411C8.53471 5.82411 9.0365 6.03125 9.41507 6.40982C9.6011 6.59532 9.74862 6.81577 9.84914 7.05848C9.94966 7.3012 10.0012 7.5614 10.0008 7.82411C10.0008 8.35804 9.79186 8.85982 9.41507 9.23839Z" fill="#667085" />
            </g>
            <defs>
              <clipPath id="clip0_17841_37421">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <Button
          className='rs-button rs-button--sm collapse-button'
          icon={isShow ? <UpOutlined /> : <DownOutlined />}
          iconPosition='end'
          onClick={() => setIsShow(!isShow)}
        >{isShow ? 'Thu gọn' : 'Mở rộng'}</Button>
      </div>

      <div className={`order-history-card__body ${isShow ? 'show' : 'collapsed'}`}>
        <div className='megatable'>
          <MegaTable
            stData={{ ...megaTableData }}
            onChange={handleMegaTableChange}
            newColumns={[]}
            listData={listData as any}
            loading={loading}
          />
        </div>
      </div>

      <ColSetting
        stData={{ ...megaTableData }}
        onChange={handleColSettingChange}
      />
    </div>
  )
}

export default PoolingDataHistoryCard
